// Dependencies
global.jQuery = require('jquery');
require('bootstrap/js/modal');
var _ = require('underscore');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');

// Channels
var channel = Radio.channel('global');

var ShowModal = Marionette.Object.extend({
    initialize: function() {
        // Show a view to the modalRegion
        channel.reply('show:modal', function(modalView) {
            if (_.isUndefined(modalView)) {
                throw new Error('modalView required to show modal');
            }

            var modalRegion = channel.request('get:regions').modalRegion;

            channel.request('destroy:modal');
            modalRegion.show(modalView);
            modalView.$el.modal();

            // Empty modalRegion when modal hidden
            modalView.$el.on('hidden.bs.modal', function() {
                modalRegion.empty();
            });
        });

        channel.reply('destroy:modal', function(modalView) {
            var modalRegion = channel.request('get:regions').modalRegion;
            var modalView = modalRegion.currentView;

            if (modalView) {
                modalView.undelegateEvents();
                modalView.$el.modal('hide');
                modalRegion.empty();
            }
        });
    },

    destroy: function() {
        channel.stopReplying('show:modal');
        channel.stopReplying('destroy:modal');
    },
});

module.exports = ShowModal;
